import { useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { useAwardCreate } from '@/module/Author/Award/model/AwardQuery';
import { AwardSchema, awardSchema, defaultAwardValues } from '@/module/Author/Award/model/AwardSchema';

import { useAppNotification } from '@feature/utils';

import { AwardForm } from './AwardForm';

export function AwardCreate() {
  const { t } = useTranslation();
  const { mutate, isPending, isError, isSuccess } = useAwardCreate();

  const notification = useAppNotification();
  const navigate = useNavigate();

  const onSubmit = (values: AwardSchema) => {
    mutate(values, {
      onError: notification.error,
      onSuccess: newAward => {
        notification.success();
        navigate({ to: '/author/award/$awardId', params: { awardId: String(newAward.id) } });
      },
    });
  };

  return (
    <AwardForm
      title={t('awards.form.title.create')}
      schema={awardSchema}
      defaultValues={defaultAwardValues}
      values={undefined}
      isSubmitting={isPending}
      isError={isError}
      isSuccess={isSuccess}
      onSubmit={onSubmit}
      onCancel={() => navigate({ to: '..' })}
    />
  );
}
